/**
 * Bar Chart Component
 * Componente para renderização de gráficos de barras usando Chart.js
 */

export function renderBarChart(abertas, concluidas) {
    if (typeof Chart === "undefined") {
        return;
    }

    const barChartBox = document.getElementById("bar-chart");

    if (!barChartBox) {
        return;
    }

    // Garantir que os dados são arrays
    const abertasArray = Array.isArray(abertas) ? abertas : [abertas];
    const concluidasArray = Array.isArray(concluidas)
        ? concluidas
        : [concluidas];

    // Labels dos meses
    const meses = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
    ];

    // Configuração do gráfico
    const data = {
        labels: meses,
        datasets: [
            {
                label: "O.S Abertas",
                data: abertasArray,
                backgroundColor: "#4940FF",
                borderColor: "#4940FF",
                borderWidth: 1,
                borderRadius: 4,
                borderSkipped: false,
            },
            {
                label: "O.S Finalizadas",
                data: concluidasArray,
                backgroundColor: "#F1F1F1",
                borderColor: "#F1F1F1",
                borderWidth: 1,
                borderRadius: 4,
                borderSkipped: false,
            },
        ],
    };

    // Obtendo contexto 2D...
    let ctx;
    try {
        ctx = barChartBox.getContext("2d");
        // Contexto 2D obtido com sucesso
    } catch (error) {
        return;
    }

    // Destruindo gráfico existente se houver
    if (window.barChart) {
        // Destruindo gráfico existente...
        window.barChart.destroy();
    }

    // Criando novo gráfico Chart.js...
    const chart = new Chart(ctx, {
        type: "bar",
        data: data,
        options: {
            responsive: false,
            maintainAspectRatio: false,
            layout: {
                padding: {
                    top: 10,
                    right: 10,
                    bottom: 10,
                    left: 10,
                },
            },
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                    align: "center",
                    usePointStyle: false,
                    labels: {
                        boxWidth: 15,
                        boxHeight: 12,
                        padding: 15,
                        font: {
                            family: "airbnb_cereal, sans-serif",
                            size: 14,
                            weight: 400,
                        },
                        color: "#333",
                    },
                },
            },
            scales: {
                y: {
                    display: true,
                    beginAtZero: true,
                    grid: {
                        display: true,
                        color: "#f0f0f0",
                    },
                    ticks: {
                        display: true,
                        font: {
                            family: "airbnb_cereal, sans-serif",
                            size: 12,
                            weight: 300,
                        },
                        color: "#666",
                    },
                },
                x: {
                    display: true,
                    grid: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                        font: {
                            family: "airbnb_cereal, sans-serif",
                            size: 12,
                            weight: 300,
                        },
                        color: "#666",
                    },
                },
            },
        },
    });

    // Armazenar referência global
    window.barChart = chart;

    // Gráfico criado com sucesso
    return chart;
}

/**
 * Função para atualizar dados do gráfico existente
 */
export function updateBarChart(abertas, concluidas) {
    // Atualizando gráfico

    if (!window.barChart) {
        // Gráfico não existe, criando novo...
        return renderBarChart(abertas, concluidas);
    }

    // Garantir que os dados são arrays
    const abertasArray = Array.isArray(abertas) ? abertas : [abertas];
    const concluidasArray = Array.isArray(concluidas)
        ? concluidas
        : [concluidas];

    // Atualizar dados
    window.barChart.data.datasets[0].data = abertasArray;
    window.barChart.data.datasets[1].data = concluidasArray;
    window.barChart.update();

    // Gráfico atualizado com sucesso
}

/**
 * Função para destruir o gráfico
 */
export function destroyBarChart() {
    if (window.barChart) {
        window.barChart.destroy();
        window.barChart = null;
        // Gráfico destruído
    }
}
